import React, { useEffect, useState } from "react";
import "./DisclaimerPopup.css";

export default function DisclaimerPopup() {
  const [checked, setChecked] = useState(false);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (sessionStorage.getItem("ng_disclaimer_accepted") === "1") {
      setVisible(false);
    }
  }, []);

  const handleConfirm = () => {
    if (!checked) return;

    const overlay = document.getElementById("cpr-overlay");
    if (overlay) {
      overlay.style.opacity = "0";
      overlay.style.transition = "opacity 0.25s ease";
      setTimeout(() => setVisible(false), 250);
    }

    sessionStorage.setItem("ng_disclaimer_accepted", "1");
  };

  if (!visible) return null;

  return (
    <div id="cpr-overlay" className="cpr-overlay">
      <div className="cpr-popup">

        <h1 className="cpr-title">Welcome to Nightingale CPR Chatbot</h1>

        <p className="cpr-text">
          This demo provides educational CPR guidance using predefined rules and
          training data. All responses are generated automatically based on the
          information you provide. No external medical datasets or
          machine‑learning models are used; the system follows structured CPR
          logic designed for training and demonstration purposes only.
        </p>

        <p className="cpr-text">
          <strong>Disclaimer:</strong> This application is for informational and
          educational purposes only. It is not a substitute for professional
          medical advice, diagnosis, certified CPR training, or emergency
          services. If you are facing a real emergency, call your local emergency
          number immediately.
        </p>

        <p className="cpr-text">
          <strong>Your privacy:</strong> No personal data or health information
          you enter is stored or shared with any third party. All processing is
          temporary and ends when your session closes.
        </p>

        <div className="cpr-checkbox">
          <input
            type="checkbox"
            checked={checked}
            onChange={() => setChecked(!checked)}
          />
          <label>I have read and understood the above</label>
        </div>

        <button
          className={`cpr-btn ${checked ? "active" : ""}`}
          onClick={handleConfirm}
        >
          I Understand
        </button>

        <div className="cpr-links">
          <a href="https://www.nightingaleheart.com/privacy">Privacy policy</a>
          <a href="https://www.nightingaleheart.com/terms">Terms of use</a>
          <a href="https://www.nightingaleheart.com/cookies">Cookie policy</a>
        </div>

      </div>
    </div>
  );
}
